import React from "react";
import { createPortal } from "react-dom";

export default function OverlayLoader({ message = "Переходим к следующему уроку…" }) {
  const safeMessage = /�/.test(message) ? "Переходим к следующему уроку…" : message;
  return createPortal(
    <div
      className="fixed inset-0 z-[2147483647] bg-black/35 backdrop-blur-sm grid place-items-center pointer-events-auto"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="flex flex-col items-center">
        <div className="relative w-14 h-14">
          <div className="absolute inset-0 rounded-full border-[5px] border-transparent border-t-[#f15525] border-r-[#38bff2] animate-spin" />
          <div className="absolute inset-2 rounded-full bg-white/80" />
        </div>
        <p className="mt-4 px-3 py-1.5 rounded-full bg-white/90 text-gray-800 text-sm shadow">
          {safeMessage}
        </p>
      </div>
    </div>,
    document.body
  );
}

